export const Services = {
   "Shipments": {
      "path": "https://obl-api-shipments.devsandbox.magicanalytics.app/",
      "method": "GET",
      "descrp": "service"
   },
   "PublicAccess": {
      "path": "https://obl-api-publicaccess.devsandbox.magicanalytics.app/",
      "method": "GET",
      "descrp": "service"
   }
}